import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sideMenuData: [],
};

const SideMenuSlice = createSlice({
  name: "SideMenuSlice",
  initialState,
  reducers: {
    setSideMenuData: (state, action) => {
      state.sideMenuData = action.payload;
    },
  },
});
export const { setSideMenuData } = SideMenuSlice.actions;

export default SideMenuSlice.reducer;